import axios from 'axios';
import getUrl from '../utils/getUrl';
import { generateApiError } from './utils/apiErrorMessages';
import changeSurveyUrlSlugSubmissionError from './submissionErrors/changeSurveyUrlSlugSubmissionError';
import { SURVEY_TYPE_COLLECTION_PATH } from './config/EntityCollectionPathMap';

export default (entityId, { slug }) =>
  axios
    .patch(getUrl.apiV2(`${SURVEY_TYPE_COLLECTION_PATH}/${entityId}/slug`), {
      slug,
    })
    .catch(
      generateApiError({
        submissionErrorMap: changeSurveyUrlSlugSubmissionError,
      }),
    );
